import type { ReactNode } from "react";
import { textLang } from "@triple-h/shared";

export function SectionHeading({
  eyebrow,
  title,
  intro,
  action,
  index,
  align = "start"
}: {
  eyebrow: string;
  title: string;
  intro?: string;
  action?: ReactNode;
  index?: string;
  align?: "start" | "center";
}) {
  return (
    <div className={`section-heading section-heading-${align}`}>
      <div className="section-heading-copy">
        <div className="section-heading-kicker">
          {index && (
            <span className="section-index" aria-hidden="true">
              {index}
            </span>
          )}
          <span className="eyebrow" lang={textLang(eyebrow)}>{eyebrow}</span>
        </div>
        <h2 lang={textLang(title)}>{title}</h2>
        {intro && <p lang={textLang(intro)}>{intro}</p>}
      </div>
      {action && <div className="section-heading-action">{action}</div>}
    </div>
  );
}
